import {
  createPlatformStage,
  deletePlatformStage,
  editPlatformStage,
  getPlatformStages
} from 'api/platformStages';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { IPlatformStage } from 'types/platformResources';
import { showPlatformApiError } from 'views/PlatformView/platformApiError';
import { NumberNameResourcePanel } from '../NumberNameResourcePanel/NumberNameResourcePanel';

interface Props {
  practiceId: number;
}

export const PracticeStagesTab: React.FC<Props> = ({ practiceId }) => {
  const { t } = useTranslation();
  const [stages, setStages] = useState<IPlatformStage[]>([]);

  const load = useCallback(async () => {
    try {
      const response = await getPlatformStages(practiceId);
      setStages(response.data);
    } catch (error) {
      showPlatformApiError(error, t);
    }
  }, [practiceId, t]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <NumberNameResourcePanel
      items={stages}
      onReload={load}
      labels={{
        add: t('platformResources.addStage'),
        edit: t('platformResources.editStage'),
        name: t('platformResources.fields.name'),
        number: t('platformResources.fields.number')
      }}
      onCreate={async (data) => {
        try {
          await createPlatformStage(practiceId, {
            stage: { ...data, practice_id: practiceId }
          });
          return true;
        } catch (error) {
          showPlatformApiError(error, t);
          return false;
        }
      }}
      onUpdate={async (id, data) => {
        try {
          await editPlatformStage(id, {
            stage: { ...data, practice_id: practiceId }
          });
          return true;
        } catch (error) {
          showPlatformApiError(error, t);
          return false;
        }
      }}
      onDelete={async (id) => {
        try {
          await deletePlatformStage(id);
          return true;
        } catch (error) {
          showPlatformApiError(error, t);
          return false;
        }
      }}
    />
  );
};
